import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { numOfDaysInA } from '../../../../settings/other';
import globals from '../../../../globals/communityGlobals';
import MatrixButton from '../shared/MatrixButton';
import { handleButtonClicks } from '../shared/functions';

const locale = globals.getArea('treatments');

const weeklySwitchValues = {
  specific: 'specific',
  weekdays: 'weekdays',
  every: 'every',
};

class SpecificTimeDetailsWeekly extends Component {
  constructor(props) {
    super(props);
    this.handleButtonClicks = handleButtonClicks.bind(this);
  }

  handleWeeklyPresetsSwitch = (event, value) => {
    const { setValue } = this.props;
    switch (value) {
      default:
      case weeklySwitchValues.specific: {
        setValue(undefined);
        break;
      }
      case weeklySwitchValues.weekdays: {
        setValue({
          0: { 1: true },
          1: { 1: true },
          2: { 1: true },
          3: { 1: true },
          4: { 1: true },
        });
        break;
      }
      case weeklySwitchValues.every: {
        setValue({
          0: { 1: true },
          1: { 1: true },
          2: { 1: true },
          3: { 1: true },
          4: { 1: true },
          5: { 1: true },
          6: { 1: true },
        });
        break;
      }
    }
  };

  weeklyTable = () => {
    const { getValue, disabled } = this.props;
    const rows = {
      0: [],
      1: [],
    };
    const keyPrefix = 'specificTimeWeeklyMatrixHeader';
    for (let day = 0; day <= numOfDaysInA.week - 1; day += 1) {
      const stateOfButtons = getValue() || {};
      const buttonState = stateOfButtons[day] && stateOfButtons[day][1] ? stateOfButtons[day][1] : false;
      rows[0].push(
        <th className="treat-sched-header" key={`${keyPrefix}Header${day}`} style={{ width: '100px' }}>
          {globals.now
            .utcOffset(0, true)
            .isoWeekday(day + 1)
            .format(globals.dateFormats.dayFull)}
        </th>,
      );
      rows[1].push(
        <MatrixButton
          key={`specificMatrixButton${day}`}
          row={day}
          position={1}
          label={buttonState ? '✔' : '-'}
          clickUpdate={!disabled ? this.handleButtonClicks : () => {}}
          checked={buttonState}
          className="treat-sched-button"
        />,
      );
    }
    return (
      <table className="treat-sched">
        <thead>
          <tr>{rows[0]}</tr>
        </thead>
        <tbody>
          <tr className="treat-sched-data-row">{rows[1]}</tr>
        </tbody>
      </table>
    );
  };

  render() {
    const { disabled } = this.props;
    return (
      <div>
        {!disabled && (
          <RadioButtonGroup
            className="row"
            style={{ flexDirection: 'column', width: '250px' }}
            name="selectionShortcuts"
            defaultSelected={weeklySwitchValues.specific}
            onChange={this.handleWeeklyPresetsSwitch}
          >
            <RadioButton
              value={weeklySwitchValues.specific}
              label={locale.getMsg('specific')}
              style={{ marginBottom: '5px' }}
            />
            <RadioButton
              value={weeklySwitchValues.weekdays}
              label={locale.getMsg('weekdays')}
              style={{ marginBottom: '5px' }}
            />
            <RadioButton
              value={weeklySwitchValues.every}
              label={locale.getMsg('everyDay')}
              style={{ marginBottom: '5px' }}
            />
          </RadioButtonGroup>
        )}
        <div style={{ marginTop: '10px' }}>{this.weeklyTable()}</div>
      </div>
    );
  }
}

SpecificTimeDetailsWeekly.defaultProps = {
  disabled: false,
};

SpecificTimeDetailsWeekly.propTypes = {
  disabled: PropTypes.bool,
  getValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default SpecificTimeDetailsWeekly;
